import axios from "@lib/axios";

export async function getFaqCategories(locale) {
  const res = await axios.get("help/faq/categories", {
    headers: { Language: locale },
  });

  return res.data.data;
}

export async function getFaqCategory(categorySlug) {
  const res = await axios.get(`help/faq/categories/${categorySlug}`);

  return res.data.data;
}

export async function getFaqArticles(locale) {
  const res = await axios.get("help/faq", {
    headers: { Language: locale },
  });

  return res.data.data;
}

export async function getFaqFeaturedArticles(locale) {
  const res = await axios.get("help/faq/featured", {
    headers: { Language: locale },
  });

  return res.data.data;
}

export async function getSupportFeaturedQuestions(locale) {
  const res = await axios.get("help/support/featured", {
    headers: { Language: locale },
  });

  return res.data.data;
}

export async function getSupportCategories(locale) {
  const res = await axios.get("help/support/categories", {
    headers: { Language: locale },
  });

  return res.data.data;
}

export async function getSupportQuestions(locale) {
  const res = await axios.get("help/support", {
    headers: { Language: locale },
  });

  return res.data.data;
}

export async function getSupportQuestion(slug, locale) {
  const res = await axios.get(`help/support/${slug}`, {
    headers: { Language: locale },
  });

  return res.data.data;
}

export async function postTicket(email, body, files) {
  const formData = new FormData();
  formData.append("ticket[email]", email);
  formData.append("ticket[body]", body);
  files.forEach((file) => formData.append("ticket[files][]", file));

  await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/help/tickets`, formData);
}
